import Seo from "@/components/feature/Seo";
import { siteMeta, faqs } from "@/mocks/manga";
import Hero from "./components/Hero";
import Story from "./components/Story";
import Volumes from "./components/Volumes";
import Chapters from "./components/Chapters";
import ColorShowcase from "./components/ColorShowcase";
import Extras from "./components/Extras";
import Feedback from "./components/Feedback";
import FaqPreview from "./components/FaqPreview";
import CtaBand from "./components/CtaBand";

export default function Home() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.slice(0, 4).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const webSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteMeta.name,
    description: siteMeta.desc,
    url: "https://sweetmanga.example.com/",
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteMeta.name,
    description: siteMeta.desc,
  };

  return (
    <>
      <Seo
        title={`${siteMeta.name} - 甜蜜惩罚漫画单行本全卷 · 连载 · 全彩 · 番外收录`}
        description={siteMeta.desc}
        keywords={siteMeta.keywords}
        canonicalPath="/"
        schema={[webSchema, orgSchema, faqSchema]}
      />
      <Hero />
      <Story />
      <Volumes />
      <Chapters />
      <ColorShowcase />
      <Extras />
      <Feedback />
      <FaqPreview />
      <CtaBand />
    </>
  );
}